import { QueryParamsType } from "src/types/query-params";
import { useSwrRequest } from "../useSwrRequest";
import qs from "qs";
import useRequest from "../useRequest";
import { Variant } from "src/types";

export const useVariants = (query: Record<string, QueryParamsType>) => {
  const url = `/variants?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    variants: (data as Array<Variant>) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
